import {FilterActions, FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {
  useTrackFilter,
  useTrackOnCloseFilter,
  useTrackOnOpenFilter,
} from './trackFilter';

type FilterObjForBulkTracking = {
  section: string;
  slug: boolean | [number, number] | number[] | string[];
  type: 'boolean' | 'range' | 'attribute';
  action: FilterActions;
  label: FilterLabels;
};

export const useViewOptionsTracking = () => {
  const filterTracker = useTrackFilter();

  const viewOptionHasBeenTracked = React.useRef(false);
  const trackOnCloseFilter = useTrackOnCloseFilter();
  const trackOnOpenFilter = useTrackOnOpenFilter();
  const trackOnCloseView = () => {
    if (!viewOptionHasBeenTracked.current) {
      trackOnCloseFilter('view', 'filter_modal');
    }
  };
  const trackOnOpenView = () => {
    viewOptionHasBeenTracked.current = false;
    trackOnOpenFilter('view', 'filter_modal');
  };
  const trackOnSelect = (
    optionId: string,
    addFilterForBulkTracking?: (filterObj: FilterObjForBulkTracking) => void,
  ) => {
    if (!addFilterForBulkTracking) {
      filterTracker('view', [optionId], 'attribute', 'submit', 'filter_modal');
    } else {
      addFilterForBulkTracking({
        section: 'view',
        slug: [optionId],
        type: 'attribute',
        action: 'submit',
        label: 'filter_modal',
      });
    }
    viewOptionHasBeenTracked.current = true;
  };

  return {
    trackOnSelect,
    trackOnCloseView,
    trackOnOpenView,
  };
};
